module.exports = __webpack_public_path__ + "img/check_white.52e43eed.svg";